import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
import { Subscribable } from 'src/shared/components/base-component/subscribable';
import { BaseDialogComponent } from 'src/shared/components/base-dialog/base-dialog.component';

@Injectable()
export class DialogService extends Subscribable {
  constructor(private readonly dialog: MatDialog) {
    super();
  }

  public openBaseDialog(
    customConfig: MatDialogConfig,
    observable$: Observable<any>,
    observableCancel$?: Observable<any>,
    onSuccess?: (value?: any) => void,
    onError?: (error?: any) => void,
    onComplete?: (error?: any) => void,
    onClose?: () => void
  ) {
    const config = {
      ...this.getBaseDialogConfig(),
      ...(customConfig && { ...customConfig }),
    };
    const ref = this.dialog.open(BaseDialogComponent, config);
    this.subscribeOne(ref.afterClosed(), (confirmed: boolean) => {
      if (!confirmed) {
        if (confirmed !== null && observableCancel$) {
          observableCancel$.pipe(take(1)).subscribe();
        }
        if (onClose) onClose();
        return;
      }

      observable$
        .pipe(
          take(1),
          tap(() => {
            if (!onSuccess) {
              // TODO: show success
            }
          }),
          catchError((error) => {
            if (!onError) {
              // TODO: show error;
            }
            throw error;
          })
        )
        .subscribe(
          (value) => {
            if (onSuccess) {
              onSuccess(value);
            }
          },
          (error) => {
            if (onError) {
              onError(error);
            }
          },
          () => {
            if (onComplete) {
              onComplete();
            }
          }
        );
    });
  }

  public getBaseDialogConfig() {
    const config: MatDialogConfig = {
      panelClass: [
        'favie-dialog__container',
      ],
      minWidth: 350,
      disableClose: true,
    };
    return config;
  }
}
